<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Clientes
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(color='', style="border-radius:5px;background-color: white;")
            v-card-title(style='padding: 8px !important;').justify-center
              img(src='../assets/logo.png', style='height: auto;width: 140px;')
        v-card(color='', style="border-radius:5px;background-color: black")
            v-card-title(style="padding: 7px;").justify-space-between
                span.white--text  Administración de Clientes
                div
                  input(type="file" ref="fileInput" @change="handleFileUpload" style="display: none" accept=".xlsx, .xls")
                  v-btn(small fab dark color="teal" @click="$refs.fileInput.click()")
                    v-icon(dark) cloud_upload

    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12 style='margin-top: 5px;')
        v-card(color='', style="border-radius: 0px 0px 20px 20px;background-color:black;")
            v-card-title(style="padding: 7px;margin-top: 0px;").justify-center
                span.white--text Lista de Clientes
        v-data-table.elevation-1(:headers='headers', :items="clientes", :search="search" style="margin-top: 5px;" hide-actions)
          template(slot='items', slot-scope='props')
            td(v-if='props.item.co_cli') {{props.item.co_cli.trim()}}
            td(v-else) - -
            td(v-if='props.item.cli_des') {{props.item.cli_des.trim()}}
            td(v-else) - -
            td(v-if='props.item.rif') {{props.item.rif.trim()}}
            td(v-else) - -
            td(v-if='props.item.telefonos') {{props.item.telefonos.trim()}}
            td(v-else) - -
            td(v-if='props.item.co_ven') {{props.item.co_ven.trim()}}
            td(v-else) - -
</template>

<script>
import clientesComService from "../services/clientesComService";
import vendedorService from "../services/vendedorService";
import * as XLSX from 'xlsx';

export default {
  name: "Clientes",
  data: () => ({
    clientes: [],
    search: '',
    headers: [
      { text: "Código", value: "co_cli" },
      { text: "Nombre", value: "cli_des" },
      { text: "RIF", value: "rif" },
      { text: "Teléfono", value: "telefonos" },
      { text: "Vendedor", value: "co_ven" },
    ],
  }),
  created() {
    this.loadClientes();
  },
  methods: {
    async loadClientes() {
        const response = await clientesComService.getClientes();
        if (!response.error) {
            this.clientes = response;
        }
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = async (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 'A' });

        
        

        const clientesAImportar = jsonData.slice(4).map(row => {
          

          return {
            co_cli: row['A'] ? String(row['A']).trim() : '',
            cli_des: row['B'] ? String(row['B']).trim() : '',
            rif: row['C'] ? String(row['C']).trim() : '',
            tip_cli: row['D'] ? String(row['D']).trim() : '',
            cond_pag: row['F'] ? String(row['F']).trim() : '',
            co_ven: row['G'] ? String(row['G']).trim() : '',
            fecha_reg: row['I'] ? new Date(row['I']) : new Date(),
            telefonos: row['J'] ? String(row['J']).trim() : '',
            estado: row['K'] ? String(row['K']).trim() : '',
            ciudad: row['M'] ? String(row['M']).trim() : '',
            direc1: row['N'] ? String(row['N']).trim() : '',
            dir_ent2: row['O'] ? String(row['O']).trim() : '',
            inactivo: false
          };
        });

        const response = await clientesComService.importClientes(clientesAImportar);
        if (!response.error) {
          this.$swal.fire("¡Éxito!", response.message, "success");
          this.loadClientes();
        } else {
          this.$swal.fire("Error", "Error al importar clientes", "error");
        }
        this.$refs.fileInput.value = '';
      };
      reader.readAsArrayBuffer(file);
    }
  }
};
</script>
